export default {
  forward: 'Forward',
  ignore: 'Ignore',
  toVoicemail: 'To Voicemail',
  answer: 'Answer',
  endAndAnswer: 'End & Answer',
  holdAndAnswer: 'Hold & Answer',
  custom: 'Custom',
  more: 'More',
} as const;
